import translates from './du.json';
import restNotifications from './notifiers.json';

export default {
  du: { ...translates, ...restNotifications },
};
